<template>
  <a href="https://apps.apple.com/app/orienteer-co/id6444422763">
    <img src="../assets/app-store.png" alt="Get the app on the app store" />
  </a>
</template>
